const DISTANCE_THRESHOLD_KM = 0.05;

function haversineKm(lat1, lon1, lat2, lon2) {
  const toRad = (v) => (v * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function normalizeAddress(str) {
  if (!str) return '';
  return str
    .toLowerCase()
    .replace(/,\s*usa$/i, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export default function findMatchingAddress(savedAddresses, candidateAddress) {
  if (!savedAddresses?.length || !candidateAddress) return null;

  const candidateNorm = normalizeAddress(candidateAddress.entered_address);
  const hasCoords =
    candidateAddress.latitude != null && candidateAddress.longitude != null;

  const exactMatch = savedAddresses.find(
    (saved) => normalizeAddress(saved.entered_address) === candidateNorm
  );
  if (exactMatch) return exactMatch;

  if (!hasCoords) return null;

  const candidateAddrNorm = normalizeAddress(candidateAddress.address);

  return (
    savedAddresses.find((saved) => {
      if (saved.latitude == null || saved.longitude == null) return false;
      if (normalizeAddress(saved.address) !== candidateAddrNorm) return false;
      const dist = haversineKm(
        saved.latitude,
        saved.longitude,
        candidateAddress.latitude,
        candidateAddress.longitude
      );
      return dist < DISTANCE_THRESHOLD_KM;
    }) || null
  );
}
